import { AIMessageHeader } from "./ai-message-header";

type ResultMessageProps = {
  content?: string;
};

export function ResultMessage({ content }: ResultMessageProps) {
  return (
    <div className="flex flex-col gap-2 pb-4">
      <AIMessageHeader />
      {content && (
        <p
          className="text-foreground font-medium"
          style={{
            width: "600px",
          }}
        >
          {content}
        </p>
      )}
    </div>
  );
}
